(function () {
  function init() {
    var header = document.querySelector('.section-header');
    if (!header) return;

    // Two different thresholds (not one) so a small back-and-forth scroll
    // near the boundary doesn't rapidly toggle the class - collapse only
    // once scrolled a bit down, re-expand only once back near the very top.
    var collapseAt = 64;
    var expandAt = 12;

    function onScroll() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop > collapseAt) {
        header.classList.add('search-row-collapsed');
      } else if (scrollTop < expandAt) {
        header.classList.remove('search-row-collapsed');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();